    <!-- Desktop View -->
    <div class="row no-gutter">
        <div class="col-12 col-md-3 p-0 d-md-block" [ngClass]="{'d-none': selectedFriend}">
            <app-friends-list [selectedFriend]="selectedFriend" (friendClicked)="selectFriendToChat($event)"></app-friends-list>
        </div>
        <div class="col-12 col-md-9 p-0 d-md-block" [ngClass]="{'d-none': !selectedFriend}">
            <app-chat-area [selectedFriend]="selectedFriend" (chatClosed)="closeChat()"></app-chat-area>
        </div>
    </div>
